import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { Modal } from '../../layouts/Modal';

import { TextField } from '../base/TextField';
import { Button } from '../base/Button';
import { SectionLoading } from '../shared/SectionLoading';

import { Toggle } from '../base/Toggle';
import { IApplianceType } from '../../types/Appliance/ApplianceType';
import useApplianceTypes from '../../data/appliance/useApplianceTypes';
import useApplianceTypeMutations from '../../data/appliance/useApplianceTypeMutations';

export interface CreateEditApplianceTypeProps {
  open: boolean;
  onClose: Dispatch<SetStateAction<boolean>>;
  applianceType?: IApplianceType;
}

export function CreateEditApplianceType({
  open,
  onClose,
  applianceType,
}: CreateEditApplianceTypeProps) {
  const { register, reset, handleSubmit } = useForm();
  const { applianceTypes } = useApplianceTypes();
  const { createApplianceType, updateApplianceType } =
    useApplianceTypeMutations();
  const [checked, setChecked] = useState(true);

  const handleClose = () => {
    onClose(false);
    setTimeout(() => reset({}), 200);
  };

  const handleCreate = (data: any) => {
    createApplianceType.mutate({ ...data, disabled: checked });
    handleClose();
  };

  const handleUpdate = (data: any) => {
    updateApplianceType.mutate({
      ...applianceType,
      ...data,
      disabled: checked,
    });
    handleClose();
  };

  useEffect(() => {
    if (applianceType) {
      setChecked(applianceType.disabled);
      reset({
        name: applianceType.name,
      });
    } else {
      setChecked(true);
      reset({});
    }
  }, [reset, applianceType]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={`${applianceType ? 'Edit' : 'Create'} Hardware Type`}
      description={`Use this form to ${
        applianceType ? 'edit' : 'create'
      } a hardware types`}
    >
      {applianceTypes.isLoading ? (
        <SectionLoading />
      ) : (
        <form
          onSubmit={handleSubmit(applianceType ? handleUpdate : handleCreate)}
          className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-y-4 sm:gap-6 sm:gap-y-4"
        >
          <TextField {...register('name')} label="Name" />

          <div className="mt-6 flex sm:col-span-2 justify-between">
            <div className="space-x-4">
              <Button type="submit">
                {applianceType ? 'Update' : 'Create'}
              </Button>
              <Button variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
            </div>
            <Toggle label="Disabled" checked={checked} onChange={setChecked} />
          </div>
        </form>
      )}
    </Modal>
  );
}
